import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import ProductsListComp from "./component";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";

const ProductListContainer = (props) => {
  const [loading, setLoading] = useState(true);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [brandList, setBrandList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredItemList, setFilteredItemList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [initialSearch, setInitialSearch] = useState(false);
  const [offset, setOffset] = useState(0);
  const [morescroll, setMorescroll] = useState(true);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isSortApplied, setIsSortApplied] = useState(false);

  const navigate = useNavigate();
  const tableContainerRef = useRef(null);
  const pageSize = 12;
  const location = useLocation();
  const scrollPositionRef = useRef(0);

  // Load data from session storage on mount
  useEffect(() => {
    const savedSearchQuery = sessionStorage.getItem("searchQuery");
    const savedFilteredItemList = JSON.parse(
      sessionStorage.getItem("filteredItemList") || "[]",
    );
    const savedBrandList = JSON.parse(
      sessionStorage.getItem("brandList") || "[]",
    );
    const savedProductList = JSON.parse(
      sessionStorage.getItem("productList") || "[]",
    );
    const savedSelectedBrands = JSON.parse(
      sessionStorage.getItem("selectedBrands") || "[]",
    );
    const savedSelectedProducts = JSON.parse(
      sessionStorage.getItem("selectedProducts") || "[]",
    );
    const savedSelectedOption = sessionStorage.getItem("selectedOption") || "";
    const savedOffset = parseInt(sessionStorage.getItem("offset") || "0");
    const savedMorescroll = sessionStorage.getItem("morescroll") !== "false";

    if (savedSearchQuery) {
      setSearchQuery(savedSearchQuery);
      setSelectedBrands(savedSelectedBrands);
      setSelectedProducts(savedSelectedProducts);
      setSelectedOption(savedSelectedOption);
      setOffset(savedOffset);
      setMorescroll(savedMorescroll);

      if (savedFilteredItemList.length > 0) {
        setFilteredItemList(savedFilteredItemList);
        setBrandList(savedBrandList);
        setProductList(savedProductList);
        setLoading(false);
        setInitialSearch(false);

        if (
          savedSelectedBrands.length > 0 ||
          savedSelectedProducts.length > 0
        ) {
          setIsFilterApplied(true);
        }
        if (savedSelectedOption) {
          setIsSortApplied(true);
        }
      } else {
        handleSearchItemList(0);
      }
    } else {
      setInitialSearch(true);
      setLoading(false);
    }
  }, []);

  // Save to session storage whenever data changes
  useEffect(() => {
    if (searchQuery) {
      sessionStorage.setItem("searchQuery", searchQuery);
    }
    if (filteredItemList.length > 0) {
      sessionStorage.setItem(
        "filteredItemList",
        JSON.stringify(filteredItemList),
      );
    }
    if (brandList.length > 0) {
      sessionStorage.setItem("brandList", JSON.stringify(brandList));
    }
    if (productList.length > 0) {
      sessionStorage.setItem("productList", JSON.stringify(productList));
    }
    if (selectedBrands.length > 0) {
      sessionStorage.setItem("selectedBrands", JSON.stringify(selectedBrands));
    } else {
      sessionStorage.removeItem("selectedBrands");
    }
    if (selectedProducts.length > 0) {
      sessionStorage.setItem(
        "selectedProducts",
        JSON.stringify(selectedProducts),
      );
    } else {
      sessionStorage.removeItem("selectedProducts");
    }
    if (selectedOption) {
      sessionStorage.setItem("selectedOption", selectedOption);
    } else {
      sessionStorage.removeItem("selectedOption");
    }
    sessionStorage.setItem("offset", String(offset));
    sessionStorage.setItem("morescroll", String(morescroll));
  }, [
    searchQuery,
    filteredItemList,
    brandList,
    productList,
    selectedBrands,
    selectedProducts,
    selectedOption,
    offset,
    morescroll,
  ]);

  useEffect(() => {
    return () => {
      clearState();
    };
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchItemList(0);
    }
  };

  const clearState = () => {
    setBrandList([]);
    setSearchQuery("");
    setFilteredItemList([]);
    setProductList([]);
    setSelectedOption("");
    setSelectedBrands([]);
    setSelectedProducts([]);
    setInitialSearch(true);
    setOffset(0);
    setMorescroll(true);
    setIsFilterApplied(false);
    setIsSortApplied(false);
    sessionStorage.removeItem("searchQuery");
    sessionStorage.removeItem("filteredItemList");
    sessionStorage.removeItem("brandList");
    sessionStorage.removeItem("productList");
    sessionStorage.removeItem("selectedBrands");
    sessionStorage.removeItem("selectedProducts");
    sessionStorage.removeItem("selectedOption");
    sessionStorage.removeItem("offset");
    sessionStorage.removeItem("morescroll");
  };

  useEffect(() => {
    if (location.state) {
      clearState();
    }
  }, [location]);

  const arrowBackClick = () => {
    navigate("/");
    clearState();
  };

  const hasFilteredItems = filteredItemList && filteredItemList.length > 0;

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchQuery(value);
    setLoading(false);
    setOffset(0);
    setMorescroll(true);
    setSelectedBrands([]);
    setSelectedProducts([]);
    setSelectedOption("");
    setIsFilterApplied(false);
    setIsSortApplied(false);
    sessionStorage.removeItem("selectedBrands");
    sessionStorage.removeItem("selectedProducts");
    sessionStorage.removeItem("selectedOption");
  };

  const handleClearAllFilters = () => {
    setSelectedBrands([]);
    setSelectedProducts([]);
    setSelectedOption("");
    setIsFilterApplied(false);
    setIsSortApplied(false);
    sessionStorage.removeItem("selectedBrands");
    sessionStorage.removeItem("selectedProducts");
    sessionStorage.removeItem("selectedOption");
    setOffset(0);
    setMorescroll(true);
    handleSearchItemList(0);
  };

  const handleBrandFilterClear = () => {
    setSelectedBrands([]);
    sessionStorage.removeItem("selectedBrands");
    setIsFilterApplied(false);

    if (selectedProducts.length > 0) {
      handleFilterAPI(selectedProducts, []);
    } else {
      setOffset(0);
      setMorescroll(true);
      handleSearchItemList(0);
    }
  };

  const handleProductFilterClear = () => {
    setSelectedProducts([]);
    sessionStorage.removeItem("selectedProducts");
    setIsFilterApplied(false);

    if (selectedBrands.length > 0) {
      handleFilterAPI([], selectedBrands);
    } else {
      setOffset(0);
      setMorescroll(true);
      handleSearchItemList(0);
    }
  };

  const handleSearchItemList = (offsetValue = 0) => {
    if (loading) return;

    if (searchQuery.trim().length < 3) {
      toastr.error("Error", "Please enter at least 3 characters for listing");
      setLoading(false);
      return;
    }

    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=&brandName=&offset=${offsetValue}&limit=${pageSize}`,
      "GET",
      undefined,
      (response) => {
        setLoading(false);
        if (
          response &&
          response.variantResponse &&
          response.brandResponse &&
          response.productResponse
        ) {
          const variantList = response.variantResponse;
          const brandList = response.brandResponse;
          const productList = response.productResponse;

          if (variantList.length < pageSize) {
            setMorescroll(false);
          } else {
            setMorescroll(true);
          }

          const updatedBrandList = mergeLists(
            brandList,
            response.brandResponse,
          );
          const updatedProductList = mergeLists(
            productList,
            response.productResponse,
          );

          setBrandList(updatedBrandList);
          setProductList(updatedProductList);

          if (offsetValue === 0) {
            setFilteredItemList(variantList);
          } else {
            setFilteredItemList((prevState) => [...prevState, ...variantList]);
          }

          sessionStorage.setItem("searchQuery", searchQuery);
          sessionStorage.setItem(
            "filteredItemList",
            JSON.stringify(
              offsetValue === 0
                ? variantList
                : [...filteredItemList, ...variantList],
            ),
          );
          sessionStorage.setItem("brandList", JSON.stringify(updatedBrandList));
          sessionStorage.setItem(
            "productList",
            JSON.stringify(updatedProductList),
          );

          setOffset(offsetValue + 1);

          if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop =
              tableContainerRef.current.scrollHeight;
          }
        } else {
          console.error("Incomplete response received");
          toastr.error("Failed", "Incomplete response received");
          setFilteredItemList([]);
          setBrandList([]);
          setProductList([]);
          setMorescroll(false);
        }
      },
      (err) => {
        console.log("API Error:", err);
        toastr.error(`${("Error", err.status.message)}`, {
          position: "top-right",
          autoClose: 1000,
        });
        setLoading(false);
        setMorescroll(true);
      },
    );
  };

  // Filter API Call - No loading state
  const handleFilterAPI = (brands, products, offsetValue = 0) => {
    console.log("=== handleFilterAPI called ===");
    console.log("Brands:", brands);
    console.log("Products:", products);

    const formatQueryParam = (arr) => arr.join(",").replace(/&/g, "%26");
    const brandsQuery = formatQueryParam(brands);
    const productsQuery = formatQueryParam(products);

    props.getDataFromAPI(
      `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=${productsQuery}&brandName=${brandsQuery}&sortBy=${selectedOption}&offset=${offsetValue}&limit=${pageSize}`,
      "GET",
      undefined,
      (response) => {
        if (
          response &&
          response.variantResponse &&
          response.brandResponse &&
          response.productResponse
        ) {
          const variantList = response.variantResponse;
          const brandList = response.brandResponse;
          const productList = response.productResponse;

          if (variantList.length < pageSize) {
            setMorescroll(false);
          } else {
            setMorescroll(true);
          }

          const updatedBrandList = mergeLists(
            brandList,
            response.brandResponse,
          );
          const updatedProductList = mergeLists(
            productList,
            response.productResponse,
          );

          setBrandList(updatedBrandList);
          setProductList(updatedProductList);

          if (offsetValue === 0) {
            setFilteredItemList(variantList);
          } else {
            setFilteredItemList((prevState) => [...prevState, ...variantList]);
          }

          sessionStorage.setItem("selectedBrands", JSON.stringify(brands));
          sessionStorage.setItem("selectedProducts", JSON.stringify(products));
          sessionStorage.setItem("selectedOption", selectedOption);
          sessionStorage.setItem(
            "filteredItemList",
            JSON.stringify(
              offsetValue === 0
                ? variantList
                : [...filteredItemList, ...variantList],
            ),
          );

          setOffset(offsetValue + 1);
          setIsFilterApplied(true);
          setIsSortApplied(selectedOption !== "");

          if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop = 0;
          }
        } else {
          console.error("Incomplete response received");
          toastr.error("Failed", "Incomplete response received");
          setFilteredItemList([]);
          setBrandList([]);
          setProductList([]);
          setMorescroll(false);
        }
      },
      (err) => {
        console.log("API Error:", err);
        toastr.error(`${("Error", err.status.message)}`, {
          position: "top-right",
          autoClose: 1000,
        });
        setMorescroll(true);
      },
    );
  };

  // Handle brand checkbox change
  const handleBrandCheckboxChange = (brandName) => {
    console.log("=== Brand Checkbox Change ===");
    console.log("Brand clicked:", brandName);

    const updatedBrands = selectedBrands.includes(brandName)
      ? selectedBrands.filter((brand) => brand !== brandName)
      : [...selectedBrands, brandName];

    setSelectedBrands(updatedBrands);
    setOffset(0);
    setMorescroll(true);

    handleFilterAPI(updatedBrands, selectedProducts);
  };

  // Handle product checkbox change
  const handleProductCheckboxChange = (productName) => {
    console.log("=== Product Checkbox Change ===");
    console.log("Product clicked:", productName);

    const updatedProducts = selectedProducts.includes(productName)
      ? selectedProducts.filter((product) => product !== productName)
      : [...selectedProducts, productName];

    setSelectedProducts(updatedProducts);
    setOffset(0);
    setMorescroll(true);

    handleFilterAPI(selectedBrands, updatedProducts);
  };

  // Handle sort change
  const handleSortChange = (event) => {
    const sortValue = event.target.value;
    console.log("=== Sort Change ===");
    console.log("Sort Value:", sortValue);

    setSelectedOption(sortValue);
    setOffset(0);
    setMorescroll(true);
    setIsSortApplied(sortValue !== "");

    if (selectedBrands.length > 0 || selectedProducts.length > 0) {
      handleFilterAPI(selectedBrands, selectedProducts);
    } else {
      handleSortSearchItemList(0, sortValue);
    }
  };

  // Search with sort - API call
  const handleSortSearchItemList = (offsetValue = 0, sortValue) => {
    if (loading) return;

    if (searchQuery.trim().length < 3) {
      toastr.error("Error", "Please enter at least 3 characters for listing");
      setLoading(false);
      return;
    }

    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=&brandName=&sortBy=${sortValue}&offset=${offsetValue}&limit=${pageSize}`,
      "GET",
      undefined,
      (response) => {
        setLoading(false);
        if (
          response &&
          response.variantResponse &&
          response.brandResponse &&
          response.productResponse
        ) {
          const variantList = response.variantResponse;
          const brandList = response.brandResponse;
          const productList = response.productResponse;

          if (variantList.length < pageSize) {
            setMorescroll(false);
          } else {
            setMorescroll(true);
          }

          const updatedBrandList = mergeLists(
            brandList,
            response.brandResponse,
          );
          const updatedProductList = mergeLists(
            productList,
            response.productResponse,
          );

          setBrandList(updatedBrandList);
          setProductList(updatedProductList);

          if (offsetValue === 0) {
            setFilteredItemList(variantList);
          } else {
            setFilteredItemList((prevState) => [...prevState, ...variantList]);
          }

          sessionStorage.setItem("selectedOption", sortValue);
          sessionStorage.setItem("searchQuery", searchQuery);
          sessionStorage.setItem(
            "filteredItemList",
            JSON.stringify(
              offsetValue === 0
                ? variantList
                : [...filteredItemList, ...variantList],
            ),
          );
          sessionStorage.setItem("brandList", JSON.stringify(updatedBrandList));
          sessionStorage.setItem(
            "productList",
            JSON.stringify(updatedProductList),
          );

          setOffset(offsetValue + 1);

          if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop =
              tableContainerRef.current.scrollHeight;
          }
        } else {
          console.error("Incomplete response received");
          toastr.error("Failed", "Incomplete response received");
          setFilteredItemList([]);
          setBrandList([]);
          setProductList([]);
          setMorescroll(false);
        }
      },
      (err) => {
        console.log("API Error:", err);
        toastr.error(`${("Error", err.status.message)}`, {
          position: "top-right",
          autoClose: 1000,
        });
        setLoading(false);
        setMorescroll(true);
      },
    );
  };

  // Infinite scroll
  const handleScrollApi = (offsetValue) => {
    if (loadingProduct) return;

    if (selectedBrands.length > 0 || selectedProducts.length > 0) {
      const formatQueryParam = (arr) => arr.join(",").replace(/&/g, "%26");
      const brandsQuery = formatQueryParam(selectedBrands);
      const productsQuery = formatQueryParam(selectedProducts);

      setLoadingProduct(true);
      props.getDataFromAPI(
        `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=${productsQuery}&brandName=${brandsQuery}&sortBy=${selectedOption}&offset=${offsetValue}&limit=${pageSize}`,
        "GET",
        undefined,
        (response) => {
          setLoadingProduct(false);
          if (
            response &&
            response.variantResponse &&
            response.brandResponse &&
            response.productResponse
          ) {
            const variantList = response.variantResponse;

            if (variantList.length < pageSize) {
              setMorescroll(false);
            }

            const updatedBrandList = mergeLists(
              brandList,
              response.brandResponse,
            );
            const updatedProductList = mergeLists(
              productList,
              response.productResponse,
            );

            setBrandList(updatedBrandList);
            setProductList(updatedProductList);

            setFilteredItemList((prevState) => [...prevState, ...variantList]);
            sessionStorage.setItem(
              "filteredItemList",
              JSON.stringify([...filteredItemList, ...variantList]),
            );

            setOffset(offsetValue + 1);

            if (tableContainerRef.current) {
              tableContainerRef.current.scrollTop = scrollPositionRef.current;
            }
          } else {
            toastr.error("Failed", "Incomplete response received");
            setMorescroll(false);
          }
        },
        (err) => {
          console.log("API Error:", err);
          toastr.error("Error", err.status.message);
          setLoadingProduct(false);
          setMorescroll(true);
        },
      );
      return;
    }

    if (selectedOption) {
      setLoadingProduct(true);
      props.getDataFromAPI(
        `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=&brandName=&sortBy=${selectedOption}&offset=${offsetValue}&limit=${pageSize}`,
        "GET",
        undefined,
        (response) => {
          setLoadingProduct(false);
          if (
            response &&
            response.variantResponse &&
            response.brandResponse &&
            response.productResponse
          ) {
            const variantList = response.variantResponse;

            if (variantList.length < pageSize) {
              setMorescroll(false);
            }

            const updatedBrandList = mergeLists(
              brandList,
              response.brandResponse,
            );
            const updatedProductList = mergeLists(
              productList,
              response.productResponse,
            );

            setBrandList(updatedBrandList);
            setProductList(updatedProductList);

            setFilteredItemList((prevState) => [...prevState, ...variantList]);
            sessionStorage.setItem(
              "filteredItemList",
              JSON.stringify([...filteredItemList, ...variantList]),
            );

            setOffset(offsetValue + 1);

            if (tableContainerRef.current) {
              tableContainerRef.current.scrollTop = scrollPositionRef.current;
            }
          } else {
            toastr.error("Failed", "Incomplete response received");
            setMorescroll(false);
          }
        },
        (err) => {
          console.log("API Error:", err);
          toastr.error("Error", err.status.message);
          setLoadingProduct(false);
          setMorescroll(true);
        },
      );
      return;
    }

    if (tableContainerRef.current) {
      scrollPositionRef.current = tableContainerRef.current.scrollTop;
    }

    setLoadingProduct(true);
    props.getDataFromAPI(
      `/partner/api/v2/productSearch/variant?variantName=${searchQuery}&productName=&brandName=&offset=${offsetValue}&limit=${pageSize}`,
      "GET",
      undefined,
      (response) => {
        setLoadingProduct(false);
        if (
          response &&
          response.variantResponse &&
          response.brandResponse &&
          response.productResponse
        ) {
          const variantList = response.variantResponse;

          if (variantList.length < pageSize) {
            setMorescroll(false);
          }

          const updatedBrandList = mergeLists(
            brandList,
            response.brandResponse,
          );
          const updatedProductList = mergeLists(
            productList,
            response.productResponse,
          );

          setBrandList(updatedBrandList);
          setProductList(updatedProductList);

          setFilteredItemList((prevState) => [...prevState, ...variantList]);
          sessionStorage.setItem(
            "filteredItemList",
            JSON.stringify([...filteredItemList, ...variantList]),
          );

          setOffset(offsetValue + 1);

          if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop = scrollPositionRef.current;
          }
        } else {
          toastr.error("Failed", "Incomplete response received");
          setMorescroll(false);
        }
      },
      (err) => {
        console.log("API Error:", err);
        toastr.error("Error", err.status.message);
        setLoadingProduct(false);
        setMorescroll(true);
      },
    );
  };

  useEffect(() => {
    const handleScroll = _.throttle(() => {
      const container = tableContainerRef.current;
      if (container) {
        const { scrollTop, clientHeight, scrollHeight } = container;
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          morescroll &&
          !loadingProduct &&
          !loading
        ) {
          handleScrollApi(offset);
        }
      }
    }, 200);

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScrollApi, offset, morescroll, loadingProduct, loading]);

  const mergeLists = (existingList, newList) => {
    const mergedList = [...existingList];
    newList.forEach((newItem) => {
      if (!existingList.some((item) => item.id === newItem.id)) {
        mergedList.push(newItem);
      }
    });
    return mergedList;
  };

  return (
    <ProductsListComp
      loading={loading}
      productList={productList}
      brandList={brandList}
      filteredItemList={filteredItemList}
      searchQuery={searchQuery}
      handleSearchChange={handleSearchChange}
      handleSearchItemList={handleSearchItemList}
      handleKeyPress={handleKeyPress}
      selectedOption={selectedOption}
      handleSortChange={handleSortChange}
      setFilteredItemList={setFilteredItemList}
      handleBrandCheckboxChange={handleBrandCheckboxChange}
      handleProductCheckboxChange={handleProductCheckboxChange}
      handleBrandFilterClear={handleBrandFilterClear}
      handleProductFilterClear={handleProductFilterClear}
      handleClearAllFilters={handleClearAllFilters}
      selectedBrands={selectedBrands}
      selectedProducts={selectedProducts}
      setSelectedBrands={setSelectedBrands}
      setSelectedProducts={setSelectedProducts}
      arrowBackClick={arrowBackClick}
      hasFilteredItems={hasFilteredItems}
      initialSearch={initialSearch}
      setInitialSearch={setInitialSearch}
      tableContainerRef={tableContainerRef}
      loadingProduct={loadingProduct}
      handleSearchClick={() => handleSearchItemList(0)}
      isFilterApplied={isFilterApplied}
      isSortApplied={isSortApplied}
    />
  );
};

function mapStateToProps(state) {
  return {
    props: state,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(ProductListContainer);
